import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { useAccessCode } from "@/context/AccessCodeContext";

export function AccessCodeModal({ open, onClose }) {
  const { info, redeem, clear } = useAccessCode();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setBusy(true);
    try {
      const ok = await redeem(code);
      if (ok) { toast.success("Código activado"); setCode(""); onClose(); } else toast.error("Código no válido o caducado");
    } catch { toast.error("No se pudo comprobar el código"); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-[#0f0f14] border border-white/10 text-white max-w-sm" data-testid="access-code-modal">
        <DialogHeader>
          <DialogTitle className="font-display font-black uppercase text-xl tracking-tight flex items-center gap-2"><span className="text-red-500">VIP</span> Código de acceso</DialogTitle>
        </DialogHeader>
        {info ? (
          <div className="space-y-4" data-testid="access-code-active">
            <div className="p-3 rounded-lg border border-emerald-700/40 bg-emerald-950/20 flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" />
              <div className="min-w-0">
                <div className="font-mono text-sm text-white">{info.code}</div>
                <div className="text-xs text-white/60">{info.label || "Código activo"} · {info.scope === "all" ? "descarga todo gratis" : info.scope === "tracks" ? "pistas gratis" : info.scope === "packs" ? "packs gratis" : "contenido seleccionado"}</div>
                {(info.max_packs != null || info.max_tracks != null) && (
                  <div className="text-xs text-emerald-300/80 mt-1 font-mono" data-testid="access-code-remaining">
                    {info.max_packs != null && `Packs: ${info.remaining?.pack ?? 0}/${info.max_packs}`}{info.max_packs != null && info.max_tracks != null && " · "}{info.max_tracks != null && `Pistas: ${info.remaining?.track ?? 0}/${info.max_tracks}`} disponibles
                  </div>
                )}
              </div>
            </div>
            <button type="button" onClick={() => { clear(); toast("Código desactivado"); }} data-testid="access-code-clear"
              className="w-full text-xs text-white/50 hover:text-red-400 py-1">Quitar código de este dispositivo</button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <p className="text-sm text-white/60">Si POMATA te ha dado un código, introdúcelo aquí para descargar gratis el contenido incluido.</p>
            <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="POMATA-XXXX" autoFocus data-testid="access-code-input"
              className="w-full bg-[#16161D] border border-white/10 rounded-lg px-3 py-2.5 text-white font-mono tracking-widest text-center uppercase focus:border-red-600/60 outline-none" />
            <button type="submit" disabled={busy || !code.trim()} data-testid="access-code-submit" className="w-full btn-red text-white py-2.5 rounded-lg font-semibold disabled:opacity-50">
              {busy ? "Comprobando…" : "Activar código"}
            </button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
